module.exports = __webpack_public_path__ + "images/emoji/telephone_receiver.c35f15319e8fae5abd3f.png";